window.$ = window.jQuery = $ = jQuery = require("jquery");
require("popper.js");
require("bootstrap");
require("owl.carousel");
require('bootstrap-select');
require("./smoothscroll");
require("./validate");
require("./form");

const WOW = require('wow.js');

import ScrollMagic from 'scrollmagic'
import { TweenMax, TimelineMax, Linear } from 'gsap'
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

jQuery.fn.mailme = function() {
    var at = / at /;
    var dot = / dot /g;
    this.each( function() {
        var addr = jQuery(this).text().replace(at,"<span>@</span>").replace(dot,".");
        var link = jQuery(this).text().replace(at,"@").replace(dot,".");
        var title = jQuery(this).attr('title')
        $(this)
            .after('<a href="mailto:'+link+'" title="'+title+'">'+ addr +'</a>')
            .remove();
    });
};

$(document).ready(() => {
    $("span.mailme").mailme();

    new WOW({
        live : true,
        animateClass : 'animated'
    }).init();
    
    $(".form-control").each(function() {
        if ($(this).val() != "") {
            $(this).closest(".form-group").addClass("focus");
        }
    });

    const selectPicker = (selector) => $(selector).selectpicker({
        mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
        width: '100%'
    });
    selectPicker('select.select-custom');
    
    $(".form-control").focus(function() {
        $(this).closest(".form-group").addClass("focus");
    }).blur(function() {
        if ($(this).val() == "") {
            $(this).closest(".form-group").removeClass("focus");
        }
    });;

    if($(window).scrollTop() > 150) {
        $("#main-menu").addClass("scrolled");
    } else {
        $("#main-menu").removeClass("scrolled");
    }

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var $mainMenu = $("#main-menu");

        if(scroll > 150) {
            $mainMenu.addClass("scrolled");
        } else {
            $mainMenu.removeClass("scrolled");
        }
    });

    $(".navbar-toggle").click(function() {
        var $menu = $(this).data("target");
        
        $($menu).toggleClass("nav-expanded");
        $("body").toggleClass("nav-expanded");
        $(this).toggleClass("nav-expanded");
    });
});

$(document).ready(() => {
    if ($("body").hasClass("page-template-about")) {
        var controllerPresentation = new ScrollMagic.Controller();
        var presentationWidth = $("#presentation").width();
        var titleWidth = $("#presentation .title-bg").width();
        var maxDirection = titleWidth - presentationWidth;
        var wipeAnimationPresentation = new TimelineMax()
            .fromTo("#presentation .title-bg", 1, {x : "0%"}, {x : -maxDirection, ease: Linear.easeNone}, 0);

            new ScrollMagic.Scene({
                triggerElement: "#presentation",
                offset: 300,
                triggerHook: "0.7",
                duration: "60%"
            })
            .setTween(wipeAnimationPresentation)
            .addTo(controllerPresentation);


        var $blockMember = $(".member-information");
        var $blockMemberName = $(".member-information .member-name");
        var $blockMemberPosition = $(".member-information .member-position");

        $(".member-profile").hover(function() {
            var memberName = $(this).data("member-name");
            var memberPosition = $(this).data("member-position");

            $blockMember.addClass("active");
            $blockMemberName.text(memberName);
            $blockMemberPosition.text(memberPosition);
        }, function() {
            $blockMember.removeClass("active");

            $blockMemberName.text("");
            $blockMemberPosition.text("");
        });

        $("#team").mousemove(function(e) {
            parallaxIt(e, ".title", -100);
            parallaxIt(e, ".content-dots img", 50);
        });
        
        function parallaxIt(e, target, movement) {
            var $this = $("#team");
            var relX = e.pageX - $this.offset().left;
            var relY = e.pageY - $this.offset().top;
            
            TweenMax.to(target, 1, {
                x: (relX - $this.width() / 2) / $this.width() * movement,
                y: (relY - $this.height() / 2) / $this.height() * movement
            });
        }
    }
});

$(document).ready(() => {
    if ($('.owl-carousel').length) {
        var $owl = $('.owl-carousel');

        $('body').on('click', '.owl-item:not(.active) a', function(e) {
            var $this = $(this);
            var $owlItem = $this.closest('.owl-item');
            
            if ($owlItem.prev().hasClass('active')) {
                $owl.trigger('next.owl.carousel');
            } else {
                $owl.trigger('prev.owl.carousel');
            }
            e.preventDefault();
        });
    }

    if ($("body").hasClass("home")) {
        $("#last-references .owl-carousel").owlCarousel({
            items : 1
        });

        $(".info-scroll").on("click", function() {
            var $this = $(this);
            var $sectionCurrent = $this.closest("section");
            var $nextSection = $sectionCurrent.next("section");
            var positionSection = $nextSection.position().top;

            $("body, html").animate({"scrollTop" : positionSection}, 500);
        });

        $("#assets .owl-carousel").owlCarousel({
            items : 1,
            dots : false,
            nav : false,
            responsive : {
                0 : {
                    margin : 15
                },
                992 : {
                    margin : 0 
                }
            }
        });

        var controller = new ScrollMagic.Controller();
        var wipeAnimation = new TimelineMax()
            .fromTo("#assets .owl-stage", 1, {x: "0%"}, {x: "-80%", ease: Linear.easeNone});

            new ScrollMagic.Scene({
                triggerElement: "#assets",
                triggerHook: "onLeave",
                duration: "300%"
            })
            .setPin("#assets")
            .setTween(wipeAnimation)
            .addTo(controller);
    };
});


$(document).ready(function () {
    var $btnNavReference = $("#menu-references-menu a");

    $btnNavReference.click(function(e) {
      var referenceName = $(this).attr('href');
      referenceName = referenceName.replace('#','');

      $btnNavReference.closest('li').removeClass('current-menu-item');
      $(this).closest('li').addClass('current-menu-item');
      
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          'action': 'load_references',
          'reference_name': referenceName
        }
      }).done(function(response) {
        $('.grid').html(response);
      });

      e.preventDefault();
    });
});

$(document).ready(() => {
    if ($("body").hasClass("page-template-services")) {
        $("#related-references .owl-carousel").owlCarousel({
            responsive : {
                0 : {
                   items : 1
                },
                992 : {
                    items : 2 
                }
            }
        });

        setTimeout('$(".mask").addClass("animate")', 1000);
    }
});


$(document).ready(() => {
    if ($("body").hasClass("single-references")) {

        if ($('.title-1').length) { 
            var controllerCover = new ScrollMagic.Controller();
            var wipeAnimationCover = new TimelineMax()
            .fromTo("#cover .title-1", 1, {x: "-100%"}, {x: "0%", ease: Linear.easeNone}, 0)
            .fromTo("#cover .title-2", 1, {x: "100%"}, {x: "0%", ease: Linear.easeNone}, 0);

            new ScrollMagic.Scene({
                triggerElement: "#cover",
                offset: -100,
                triggerHook: "0.7",
                duration: "90%"
            })
            .setTween(wipeAnimationCover)
            .addTo(controllerCover);
        }

        if ($(".frame-scrollable").length) {
            var controllerDesign = new ScrollMagic.Controller();
            var contentHeight = $(".frame").height();
            var frameImg = $(".frame img").height();
            var maxY = frameImg - contentHeight;
            var wipeAnimationDesign = new TimelineMax()
                .fromTo(".section-design-image .frame img", 1, {y: "0"}, {y: -maxY, ease: Linear.easeNone});
        
                new ScrollMagic.Scene({
                    triggerElement: ".section-design-image",
                    offset: "0",
                    triggerHook: "onLeave",
                    duration: "95%"
                })
                .setPin(".section-design-image")
                .setTween(wipeAnimationDesign)
                .addTo(controllerDesign);
        }
    }
});